import { ContainedButton } from "@/common";
import { styled } from "@mui/material";

export const ContainerHeading = styled("div")({
  backgroundColor: "rgba(5, 34, 35, 0.12)",
  borderRadius: "12px",
  padding: "25px",
  position: "relative",
  "& svg": {
    color: "#fff",
  },

  "& h6": {
    marginTop: "10px",
    fontWeight: 400,
  },
});

export const StyledContainedButton = styled(ContainedButton)(() => ({
  width: "100% !important",
  borderRadius: "6px !important",
  borderColor: "#E6E7E7",
}));
